import axios from 'axios'
import { reject } from 'lodash'
import * as apiroutes from '../../apiroutes'
import localStorageService from './localStorageService';

class ConfigurationServices{

    //*****Organization configuration*****

    //ADD Organization Configuration(OrgType)
    addNewOrganizationConfig = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("at: ", accessToken)
        
        const a = new Promise((resolve, reject) => {

            axios
                .post(apiroutes.ORG_CONFIG, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    }

    //get organization Configuration
    getOrganizationConfig = async () => {
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.ORG_CONFIG)
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    //get organizationconfigTypeByID 
    getOrganizationConfigByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.ORG_CONFIG + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }

    //*****Expense configuration*****

    //post project type expense config
    addNewProjectTypeExpenseConfig = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("at: ", accessToken)
        
        const a = new Promise((resolve, reject) => {

            axios
                .post(apiroutes.PROJECT_TYPE, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    }

    //get project type details
    getProjectTypeExpenseConfig = async () => {
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.PROJECT_TYPE)
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    //get project type by ID
    getProjectTypeConfigByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.PROJECT_TYPE + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }


    //post currency type expense config
    addNewCurrencyTypeExpenseConfig = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("at: ", accessToken)
        
        const a = new Promise((resolve, reject) => {

            axios
                .post(apiroutes.CURRENCY_TYPE, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    }
    //get currrency type details
    getCurrencyTypeExpenseConfig = async () => {
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.CURRENCY_TYPE)
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    //getCurrencyTypeByID
    getCurrencyTypeConfigByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.EXPENSE_CURRENCY_TYPE_REVIEW + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }
    
    //post expense category type expense config
    addNewExpenseCategoryTypeExpenseConfig = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken");
        // console.log("at: ", accessToken)
        
        const a = new Promise((resolve, reject) => {

            axios
                .post(apiroutes.EXPENSE_CATEGORY_TYPE, data, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    }
    //get expense category type details
    getExpenseCategoryTypeExpenseConfig = async () => {
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.EXPENSE_CATEGORY_TYPE)
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    //getExpenseCategoryTypeByID
    getExpenseCategoryTypeConfigByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.EXPENSE_CATEGORY_REVIEW + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }


    //*****Target configuration*****

    //Add new target type configuration
    addNewTargetTypeConfig = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken")
        //console.log("AT",accessToken)

        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.TARGET_TYPE, data, {
                    headers: {
                        Authorization:`Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    }

    //get target type configuration
    getTargetTypeConfig = async () => {
        const accessToken = await localStorageService.getItem("accessToken")
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.TARGET_TYPE, {
                    headers: {
                        Authorization:`Bearer ${accessToken}`
                    }
                })
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

   //Add new target details configuration
    addNewTargetDetails = async (data) => {
        const accessToken = await localStorageService.getItem("accessToken")
        //console.log("AT",accessToken)

        const a = new Promise((resolve, reject) => {
            axios
                .post(apiroutes.TARGET_DETAILS, data, {
                    headers: {
                        Authorization:`Bearer ${accessToken}`
                    }
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        console.log("ano", a);
        return await a
    } 

    //getTaegetTypeDetils
    getTargetTypeData = async () => {
        const accessToken = await localStorageService.getItem("accessToken")
        const a = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.TARGET_DETAILS, {
                    headers: {
                        Authorization:`Bearer ${accessToken}`
                    }
                })
                .then(res => {
                    return resolve(res);
                })
                .catch((error) => {
                    console.log("error", error);
                    return resolve(error);
                })
        });
        return await a;
    }

    //getTargetTypebyID
    getTargetTypeByID = async (id) => {
        const accessToken = await localStorageService.getItem('accessToken')
        console.log("accessToken", accessToken);
        const promise = new Promise((resolve, reject) => {
            axios
                .get(apiroutes.TARGET_TYPE + `/${id}`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`
                    },
                    
                })
                .then((res) => {
                    return resolve(res)
                })
                .catch((error) => {
                    console.log('error', error)
                    return resolve(error)
                })
        })
        return await promise
    }

}
export default new ConfigurationServices()